import { gql } from '@apollo/client';

const STOP_STUDY_MUTATION = gql`
  mutation stopStudy($studyFid: Int!) {
    stopStudy(studyFid: $studyFid) {
      isSuccess
      message
    }
  }
`;

export default STOP_STUDY_MUTATION;
